import { OrderStatusEnum } from '@ztechapps/common.contract'

export const isStatusBeforeInTransit = (status: string) => {
  return (
    status === OrderStatusEnum.InCart ||
    status === OrderStatusEnum.Quotation ||
    status === OrderStatusEnum.Order ||
    status === OrderStatusEnum.InProgress ||
    status === OrderStatusEnum.ReadyForPayment ||
    status === OrderStatusEnum.Paid ||
    status === OrderStatusEnum.Packing
  )
}
